// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from ConnectBar.jsx
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/ConnectBar.jsx
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// ConnectBar.jsx
//
// The standard wallet connect bar used by the Track-C apps. Wraps
// RainbowKit's ConnectButton with our own truncated-address display and an
// optional auth-status pill.

import React from 'react';
import { Box, Chip, Stack, Tooltip, Typography } from '@mui/material';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { useAuthToken } from './useAuthToken';

function truncate(addr) {
  if (!addr || addr.length < 10) return addr || '';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

export function ConnectBar({ compact = false, showStatus = true, sx }) {
  const { address, isConnected } = useAccount();
  const token = useAuthToken();
  const signedIn = isConnected && !!token;

  return (
    <Stack
      direction="row"
      spacing={{ xs: 0.5, sm: 1.5 }}
      alignItems="center"
      sx={{ flexShrink: 0, ...(sx || {}) }}
    >
      {isConnected && !compact && (
        <Tooltip title={address || ''}>
          <Typography
            color="text.secondary"
            variant="body2"
            sx={{ display: { xs: 'none', md: 'inline' } }}
          >
            {truncate(address)}
          </Typography>
        </Tooltip>
      )}
      {showStatus && isConnected && (
        <Chip
          size="small"
          // "Connected" (not "Signing in…") when there is no auth token: apps that
          // opt out of auto-auth (the bridge — public/non-custodial) never obtain a
          // token, so a perpetual orange "Signing in…" was misleading. Auth-enabled
          // apps briefly show "Connected" then flip to "Signed in" once the JWT lands.
          label={signedIn ? 'Signed in' : 'Connected'}
          color={signedIn ? 'success' : 'default'}
          sx={{
            height: 22,
            fontSize: '0.7rem',
            display: { xs: 'none', sm: 'inline-flex' },
          }}
        />
      )}
      <Box>
        <ConnectButton
          accountStatus={{ smallScreen: 'avatar', largeScreen: 'avatar' }}
          chainStatus={{ smallScreen: 'icon', largeScreen: 'icon' }}
          showBalance={false}
        />
      </Box>
    </Stack>
  );
}

export default ConnectBar;
